import axios from 'axios'
import { TokenService } from '../services/storage.service'
import NProgress from "nprogress";


axios.interceptors.request.use(config => {
    NProgress.start()
    return config
})

axios.interceptors.response.use(response => {
    NProgress.done()
    return response
});




const ApiService = {

    init(baseURL: string) {
        axios.defaults.baseURL = baseURL;
    },

    setHeader() {
        axios.defaults.headers.common["Authorization"] = `Bearer ${TokenService.getToken()}`
    },

    removeHeader() {
        axios.defaults.headers.common = {}
    },

    get(resource: string) {
        return axios.get(resource)
    },

    post(resource: string, data: object) {
        return axios.post(resource, data)
    },

    put(resource: string, data: object) {
        return axios.put(resource, data)
    },

    delete(resource: string) {
        return axios.delete(resource)
    },

    /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
     **/
    customRequest(data: object) {
        return axios(data)
    }
}

export default ApiService
